<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <h3 class="title text-2xl font-medium">
        {{ title }}
      </h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "report-page-header",
  props: ["title"],
  methods: {}
};
</script>
